/**
 * Returns stores linked to the selected recipe variants.
 * The main recipe option covers stores that are not assigned to any variant.
 */
export const getStoresForSelectedVariants = ({
  stores,
  recipeVariants,
  selectedVariants,
  mainRecipeOptionId,
}) => {
  if (!selectedVariants.length) {
    return [];
  }

  const storeIdsAssociatedToVariants = recipeVariants.reduce((result, variant) => {
    (variant.storeIds ?? []).forEach((storeId) => {
      result.add(storeId);
    });

    return result;
  }, new Set());

  const variantStoreIdsByVariantId = new Map(
    recipeVariants.map((variant) => [variant.id, new Set(variant.storeIds ?? [])]),
  );

  const allowedStoreIds = new Set();

  selectedVariants.forEach(({ id }) => {
    if (id === mainRecipeOptionId) {
      stores.forEach((store) => {
        if (!storeIdsAssociatedToVariants.has(store.id)) {
          allowedStoreIds.add(store.id);
        }
      });

      return;
    }

    const variantStoreIds = variantStoreIdsByVariantId.get(id);

    if (!variantStoreIds) {
      return;
    }

    variantStoreIds.forEach((storeId) => {
      allowedStoreIds.add(storeId);
    });
  });

  return stores.filter(({ id }) => allowedStoreIds.has(id));
};
